import { render, staticRenderFns } from "./glbUpload.vue?vue&type=template&id=30c3b0e3&scoped=true"
import script from "./glbUpload.vue?vue&type=script&lang=js"
export * from "./glbUpload.vue?vue&type=script&lang=js"
import style0 from "./glbUpload.vue?vue&type=style&index=0&id=30c3b0e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c3b0e3",
  null
  
)

export default component.exports